<div class="tab-content">
  <div id="pills-personal" role="tabpanel" aria-labelledby="pills-personal-tab">




    <form *ngIf="applicantData" [formGroup]="basicApplicantInfo" class="editForm" novalidate>
      <h5>Personal Information</h5><br />

      <h6 class="text-primary">Section A | Your Name: {{getFullName()}}</h6>
      <hr />
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>

              Last Name/Surname/Family Name
              <small class="text-muted">(required)</small>

            </label>
            <input type="text" formControlName="LastName" class="form-control" placeholder="Last Name">
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>
              First Name <small class="text-muted">(required)</small>
            </label>
            <input type="text" formControlName="FirstName" class="form-control" placeholder="First Name">
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="form-group">
            <label>Middle Name(s)</label>
            <input type="text" formControlName="OtherName" class="form-control" placeholder="Middle Name(s)">
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Sex <small class="text-muted">(required)</small></label>
            <select formControlName="GenderId" class="form-control">
              <option value="">SELECT SEX</option>
              <option *ngFor="let item of genders" value="{{item.ValueId}}">
                {{item.DisplayValue}}

            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>
              Date Of Birth (Month/Day/Year) <small class="text-muted">(required)</small>
            </label>
            <input type="date" formControlName="DateOfBirth" class="form-control">
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <label>
              Place of Birth <small class="text-muted">(required)</small>
            </label>
            <input type="text" formControlName="PlaceOfBirth" class="form-control" placeholder="Place of Birth">
          </div>
        </div>
      </div>


      <div class="row">

        <div class="col-md-6">
          <div class="form-group">
            <label>
              Title <small class="text-muted">(required)</small>
            </label>
            <select formControlName="TitleId" class="form-control">
              <option value="">SELECT TITLE</option>
              <option *ngFor="let item of titles" value="{{item.ValueId}}">
                {{item.DisplayValue}}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>
              Marital Status <small class="text-muted">(required)</small>
            </label>
            <select formControlName="MarritalStatusId" class="form-control">
              <option value="">Select marital status</option>
              <option *ngFor="let item of maritalStatus" value="{{item.ValueId}}">
                {{item.DisplayValue}}
              </option>
            </select>
          </div>
        </div>


      </div>
      <h6 class="text-primary">Section B</h6>
      <hr />

      <div class="row">


        <div class="col-md-6" *ngIf="!isForignStudent()">
          <div class="form-group">
            <label>
              Ethnic Group <small class="text-muted">(required)</small>
            </label>
            <select formControlName="EthnicGroupId" class="form-control">
              <option value="">Select Ethnic Group</option>
              <option *ngFor="let item of ethnicGroups" value="{{item.ValueId}}">
                {{item.DisplayValue}}
              </option>

            </select>
          </div>
        </div>




        <div class="col-md-6">
          <div class="form-group">
            <label>
              Religion <small class="text-muted">(required)</small>
            </label>
            <select formControlName="ReligionId" class="form-control">
              <option value="">Select your religion</option>
              <option *ngFor="let item of religions" value="{{item.ValueId}}">
                {{item.DisplayValue}}
              </option>

            </select>
          </div>
        </div>

      </div>



      <div class="row">



        <div class="col-md-6">
          <div class="form-group">
            <label>
              Who introduced UMaT to you? <small class="text-muted">(required)</small>
            </label>
            <select formControlName="MarketingMethodId" class="form-control">
              <option *ngFor="let item of marketingMethods" value="{{item.ValueId}}">
                {{item.DisplayValue}}
              </option>

            </select>
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <label>Why did you choose UMaT</label>
            <input type="text" formControlName="WhyUs" class="form-control" />

          </div>
        </div>


      </div>

      <div class="row">



        <div class="col-md-6">
          <div class="form-group">
            <label>Why did you choose a discipline of Engineering</label>
            <input type="text" formControlName="WhyEngineering" class="form-control" />

          </div>
        </div>


        <div class="col-md-6">

        </div>


      </div>

      <div class="row">



        <div class="col-md-6">
          <div class="form-group">
            <label>
              Have you experienced any chronic disease or mental health issue? <small
                class="text-muted">(required)</small>
            </label>
            <select formControlName="IsDisability" class="form-control">
              <option *ngFor="let item of yesOrNo" value="{{item.Id}}">
                {{item.Name}}
              </option>

            </select>
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <label *ngIf="!getDisabilityReason()">If yes, Specify (required)</label>
            <label *ngIf="getDisabilityReason()">If yes, Specify </label>
            <input [readOnly]="getDisabilityReason()" formControlName="DisabilityReason" type="text" autofocus
              class="form-control" placeholder="">

          </div>
        </div>


      </div>


      <!-- <pre>{{ basicApplicantInfo.value | json }}</pre>
                        <h4>{{basicApplicantInfo.valid}}</h4> -->


      <button class="btn btn-default waves-effect waves-light m-1 float-left"
        (click)="goToPrevious(basicApplicantInfo)"><i class="fa fa-backward"></i> Go Back</button>
      <button class="btn btn-primary waves-effect waves-light m-1 float-right" id="next"
        [disabled]="!basicApplicantInfo.valid" (click)="goToNext(basicApplicantInfo)">Save &amp; Continue</button>

    </form>
    <!-- showLoadingIndicator -->
    <app-loader-v1 *ngIf="showLoadingIndicator"></app-loader-v1>

  </div>

</div>